import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  ModuleWithProviders,
  NgModule
} from '@angular/core';
import {
  AuthorizationService,
  PostWithContinueService,
  PostWithCredService,
  PostWithFingerPrintService,
  PostWithRememberUserService,
  RedirectfulService,
  RememberMeWrapperService,
  SwapAccessTokenService,
  UtilMethodsHelperService,
  UtilMethodsService,
  UtilService,
  UtilServiceHelperService,
  UtilServiceHelperSupportService
} from '@com-delta-idp/mnx-oauth';
import { ExceptionTrackingService } from '@com-delta-idp/mnx-utils';
import { StoreModule } from '@ngrx/store';
import { AlertAdvisoriesModule } from './common/alert-advisories/alert-advisories.module';
import { NgcCommonModule } from './common/common.module';
import { CookieBannerModule } from './common/cookie-banner/cookie-banner.module';
import { CountryLanguageHelper } from './common/country-language-helper';
import { CountryLanguageResolver } from './common/country-language-resolver';
import { DataLayerModule } from './common/datalayer/datalayer.module';
import { DeviceTypeHelper } from './common/device-type-helper';
import { Constants } from './common/flight-search/constants';
import { FlightSearchUtils } from './common/flight-search/flight-search-util';
import { QueryStringHelper } from './common/query-string-helper';
import { SessionTimeOutModule } from './common/session-time-out/session-time-out.module';
import { NgcSkipNavigationModule } from './common/skip-navigation/skip-navigation.module';
import { TrackJsErrorHandler } from './common/trackjs/trackjs.handler';
import { NGC_CONFIG, NgcConfig } from './config/config';
import { INgcConfig } from './config/config.interface';
import { ConfigModule } from './config/config.module';
import { NgcFooterModule } from './footer/global-footer.module';
import { BusinessAlertModule } from './header/business-alert/business-alert.module';
import { NgcSlimHeaderModule } from './header/global-nav-slim/global-nav-slim.module';
import { NgcHeaderModule } from './header/global-nav.module';
import { InterstitialScreenModule } from './header/interstial-screen/interstitial-screen.module';
import { TimeoutInterceptor } from './interceptor/timeout.interceptor';
import { NgcPipesModule } from './pipes/module';
import { AccountSummaryService } from './services/accountsummary/account-summary.service';
import { TrackerDataService } from './services/acctactvty/trackerData.service';
import { ClosestAirPortcode } from './services/closestairportcode.service';
import { ContentHeaderFooterService } from './services/content/contentheaderfooter.service';
import { CountryLanguageService } from './services/country_Language/country_Language.service';
import { ErrorMessageService } from './services/error-messages/error-messages.service';
import { FeatureFlagService } from './services/feature-flag.service';
import { FlyoutExternalSiteService } from './services/flyout-externalsite-service/flyout-externalsite.service';
import { LoginServiceWorkerService } from './services/login-service-worker.service';
import { LogoutService } from './services/logout/logout.service';
import { MDotService } from './services/mdot/mdot.service';
import { TripService } from './services/mydelta-trip-service/trip.service';
import { SearchService } from './services/search/search.service';
import { SiteSearchPeService } from './services/search/site-search-pe.service';
import { TranslatedsitesLangService } from './services/translatedsites/translatedsiteslang.service';
import { UpcomingTripService } from './services/upcoming-trip-service/upcoming-trip.service';
import { commonReducer } from './store/reducers/common.reducer';
import { errorMessageReducer } from './store/reducers/error-message.reducer';
import { formReducer } from './store/reducers/form.reducer';
import { slimNavReducer } from './store/reducers/slim-nav.reducer';
import { CommonReducerStoreService } from './store/services/common.reducer.service';
import { ErrorMessagesReducerStoreService } from './store/services/error-message.reducer.service';
const MODULES = [
  NgcCommonModule,
  NgcHeaderModule,
  NgcFooterModule,
  NgcSkipNavigationModule,
  CookieBannerModule,
  InterstitialScreenModule,
  BusinessAlertModule,
  StoreModule,
  HttpClientModule,
  NgcPipesModule,
  AlertAdvisoriesModule,
  SessionTimeOutModule,
  DataLayerModule,
  ConfigModule,
  NgcSlimHeaderModule
];

@NgModule({
  exports: MODULES,
  imports: [
    HttpClientModule,
    StoreModule.forRoot({
      commonReducer: commonReducer,
      formReducer: formReducer,
      errorMessageReducer: errorMessageReducer,
      slimNavReducer: slimNavReducer
    }),
    DataLayerModule
  ],
  providers: [
    [{ provide: ErrorHandler, useClass: TrackJsErrorHandler }],
    CommonReducerStoreService,
    Constants
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NgcModule {
  static forRoot(config: INgcConfig = {}): ModuleWithProviders<NgcModule> {
    return {
      ngModule: NgcModule,
      providers: [
        NgcConfig,
        {
          provide: NGC_CONFIG,
          useValue: config
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TimeoutInterceptor,
          multi: true
        },
        CountryLanguageResolver,
        ErrorMessageService,
        TranslatedsitesLangService,
        ErrorMessagesReducerStoreService,
        AccountSummaryService,
        CountryLanguageService,
        CountryLanguageHelper,
        ClosestAirPortcode,
        DeviceTypeHelper,
        LogoutService,
        QueryStringHelper,
        FlyoutExternalSiteService,
        TrackerDataService,
        TripService,
        MDotService,
        SearchService,
        FlightSearchUtils,
        UpcomingTripService,
        ContentHeaderFooterService,
        RememberMeWrapperService,
        AuthorizationService,
        PostWithFingerPrintService,
        PostWithCredService,
        PostWithRememberUserService,
        PostWithContinueService,
        SwapAccessTokenService,
        RedirectfulService,
        UtilService,
        UtilMethodsService,
        UtilMethodsHelperService,
        UtilServiceHelperService,
        UtilServiceHelperSupportService,
        LoginServiceWorkerService,
        FeatureFlagService,
        ExceptionTrackingService,
        SiteSearchPeService
      ]
    };
  }
}
